import { createFileRoute } from '@tanstack/react-router'
import DataTable, { type ColumnDef } from '@/components/core/data-table'
import { Searchbar } from '@/components/core/searchbar'
import Pagination from '@/components/core/pagination'
import { formatDate } from '@/utils/format-date'
import { Content } from '@/components/layouts/content'
import { Header } from '@/components/layouts/header'
import { Link } from '@tanstack/react-router'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/core/tabs.tsx'

export const Route = createFileRoute('/_dashboard/case-processing')({
  component: RouteComponent,
})

function RouteComponent() {
  type Cases = {
    service_type: string
    payor_type: string
    court_level: string
    court_type: string
    court_office: string
    created_at: string
    status: string
  }

  const columns: ColumnDef<Cases>[] = [
    {
      id: 'service_type',
      label: 'Service Type',
      cell: ({ data, onClick }) => (
        <Link
          to="/case-processing/1"
          className="font-semibold text-base text-blue-600"
        >
          {data.service_type}
        </Link>
      ),
    },
    {
      id: 'payor_type',
      label: 'Payor Type',
      cell: ({ data }) => data.payor_type,
    },
    {
      id: 'court_level',
      label: 'Court Level',
      cell: ({ data }) => data.court_level,
    },
    {
      id: 'court_type',
      label: 'Court Type',
      cell: ({ data }) => data.court_type,
    },
    {
      id: 'court_office',
      label: 'Court Station/Office',
      cell: ({ data }) => data.court_office,
    },
    {
      id: 'status',
      label: 'Status',
      cell: ({ data }) => data.status,
    },
    {
      id: 'created_at',
      label: 'Created',
      cell: ({ data }) => formatDate(data.created_at),
    },
  ]

  const cases: Cases[] = [
    {
      service_type: 'File Case, Supplemental Pleadings, and Answers',
      payor_type: 'Individual',
      created_at: '2025-01-10',
      court_level: '2ND LEVEL COURT',
      court_type: 'Regional Trial Court',
      court_office: 'MAKATI CITY',
      status: 'Pending',
    },
    {
      service_type: 'Filing of Applications, Motions, or Requests',
      payor_type: 'Individual',
      created_at: '2025-01-08',
      court_level: '2ND LEVEL COURT',
      court_type: 'Regional Trial Court',
      court_office: 'MAKATI CITY',
      status: 'Pending',
    },
    {
      service_type: 'Other Services',
      payor_type: 'Individual',
      created_at: '2025-01-05',
      court_level: '1ST LEVEL COURT',
      court_type: 'Municipal Trial Court',
      court_office: 'MAKATI CITY',
      status: 'Pending',
    },
  ]

  const handleEdit = () => {
    alert('Edit Mode')
  }

  const handleArchive = () => {
    alert('Edit Mode')
  }

  return (
    <Content>
      <Header />
      <div className="flex flex-col w-full p-4">
        <div className="flex flex-col w-full">
          {/* <Tabs orientation="vertical" defaultValue="pending">
            <TabsList>
              <TabsTrigger value="pending">Pending</TabsTrigger>
              <TabsTrigger value="verified">Verified</TabsTrigger>
              <TabsTrigger value="dismissed">Dismissed</TabsTrigger>
            </TabsList>
            <TabsContent value="pending">
              <Searchbar />
              <DataTable
                data={cases}
                columns={columns}
                onEdit={handleEdit}
                onRowClick={handleEdit}
                onDelete={handleArchive}
              />
              <Pagination
                onClick={() => {
                  alert('Wow')
                }}
                initialPage={1}
                pageCount={4}
              />
            </TabsContent>
            <TabsContent value="verified">
              <Searchbar />
              <DataTable
                data={cases}
                columns={columns}
                onEdit={handleEdit}
                onRowClick={handleEdit}
                onDelete={handleArchive}
              />
              <Pagination
                onClick={() => {
                  alert('Wow')
                }}
                initialPage={1}
                pageCount={4}
              />
            </TabsContent>
            <TabsContent value="dismissed">
              <Searchbar />
              <DataTable
                data={cases}
                columns={columns}
                onEdit={handleEdit}
                onRowClick={handleEdit}
                onDelete={handleArchive}
              />
              <Pagination
                onClick={() => {
                  alert('Wow')
                }}
                initialPage={1}
                pageCount={4}
              />
            </TabsContent>
          </Tabs> */}

          <Tabs orientation="horizontal" defaultValue="pending">
            <TabsList>
              <TabsTrigger value="pending">Pending</TabsTrigger>
              <TabsTrigger value="verified">Verified</TabsTrigger>
              <TabsTrigger value="dismissed">Dismissed</TabsTrigger>
            </TabsList>
            <TabsContent value="pending">
              <Searchbar />
              <DataTable
                data={cases}
                columns={columns}
                onEdit={handleEdit}
                onRowClick={handleEdit}
                onDelete={handleArchive}
              />
              <Pagination
                onClick={() => {
                  alert('Wow')
                }}
                initialPage={1}
                pageCount={4}
              />
            </TabsContent>
            <TabsContent value="verified">
              <Searchbar />
              <DataTable
                data={cases}
                columns={columns}
                onEdit={handleEdit}
                onRowClick={handleEdit}
                onDelete={handleArchive}
              />
              <Pagination
                onClick={() => {
                  alert('Wow')
                }}
                initialPage={1}
                pageCount={4}
              />
            </TabsContent>
            <TabsContent value="dismissed">
              <Searchbar />
              <DataTable
                data={cases}
                columns={columns}
                onEdit={handleEdit}
                onRowClick={handleEdit}
                onDelete={handleArchive}
              />
              <Pagination
                onClick={() => {
                  alert('Wow')
                }}
                initialPage={1}
                pageCount={4}
              />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </Content>
  )
}
